<template>
  <div class="page-container">
    <md-app md-waterfall class="app-container">
      <md-app-content class="center-grow-box">
        <!-- Form Display -->
        <div class="container directory-id" v-if="!sent">
          <transition-group name="error-transition" mode="out-in">
            <md-empty-state v-if="tooManyRequestsError"
                            md-icon="warning"
                            md-label="Too many requests"
                            md-description="Please try again later."
                            key="tooManyError">
            </md-empty-state>
            <md-empty-state v-else-if="error"
                            md-icon="error_outline"
                            md-label="Resource not found."
                            md-description="Please consult your health care organization for the correct address."
                            key="error">
            </md-empty-state>
            <div v-else key="home">
              <img v-if="logo_url !== ''" :src="logo_url" class="big-logo" />
              <md-field>
                <label>Directory Identifier</label>
                <md-input autofocus v-model="form.id" v-on:keyup.enter="submit"></md-input>
              </md-field>

              <div class="dn-row">
                <div class="filler" />
                <md-button class="md-raised md-primary"
                           :disabled="disableSubmit"
                           @click="submit">Next</md-button>
                <div class="filler" />
              </div>
            </div>
          </transition-group>
        </div>
        <!-- Sent Display -->
        <div class="message-sent" v-if="sent">Message was sent!</div>
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
const faviconUrl = '/c/favicon.png';

export default {
  name: 'home',
  props: {
    siteKey: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      logo_url: '',
      form: {
        id: '',
      },
      sent: false,
      sending: false,
      error: false,
      tooManyRequestsError: false,
    };
  },
  metaInfo() {
    return {
      link: [
        { rel: 'icon', href: this.logo_url || faviconUrl }
      ]
    }
  },
  computed: {
    disableSubmit() {
      return this.form.id === '';
    },
  },
  methods: {
    submit() {
      if (this.form.id.length < 2) {
        return;
      }

      this.$router.push({ name: 'form', params: { id: this.form.id } });
    },
    getSiteLogo() {
      this.$axios.get(`/api/sites/${this.siteKey}`).then(({ data }) => {
        this.logo_url = data.logo_url;
      }).catch((e) => {
        // Will be handled by rollbar
        if(e.response && e.response.status === 429) {
          this.tooManyRequestsError = true;
        } else {
          this.error = true;
        }
        console.log('Error getting site logo', e);
      });
    },
  },
  created() {
    this.getSiteLogo();
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  height: 0;
  .big-logo {
    margin: 20px auto;
    display: block;
    width: 200px;
    border-radius: 6px;
    overflow: hidden;
  }
  .directory-id {
    max-width: 200px;
    .md-button {
      width: 200px;
      margin-left: 0;
      margin-right: 0;
    }
  }
  .error-transition-enter-active {
    transition: opacity 0.5s;
  }
  .error-transition-enter, .error-transition-leave-to {
    opacity: 0;
  }
}
</style>
